module.exports = __webpack_public_path__ + "img/7-parameters-pre.d684d21e.png";